export { ImageGalleryModal } from "./ImageGalleryModal";
export type {
	ImageGalleryModalProps,
	ImageGalleryModalSlide
} from "./ImageGalleryModal";
